import "./lib/polyfills";
import "./lib/error-logger";
import {createRoot} from "react-dom/client";

// The raw literal, not the flags from lib/app-mode: the `import()` of the other two apps has to
// be gone before rolldown builds the module graph, or their chunks land in this build anyway.
const mode = process.env.REACT_APP_MODE;

// Register service worker (only for main app, not steamy or open modes)
if ("serviceWorker" in navigator && mode !== "steamy" && mode !== "open") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch((err) => {
      console.warn(err);
    });
  });
}

let appPromise;

if (process.env.REACT_APP_MODE === "steamy") {
  appPromise = import("./features/steamy/SteamyApp.jsx");
} else if (process.env.REACT_APP_MODE === "open") {
  appPromise = import("./features/public-project/PublicProjectApp.jsx");
} else {
  appPromise = import("./App");
}

const onLoaded = new Promise((res) => window.document.addEventListener("DOMContentLoaded", res));

Promise.all([appPromise, onLoaded]).then(([{default: App}]) => {
  const appEl = window.document.getElementById("app");

  const root = createRoot(appEl);
  root.render(<App tab="home" />);
  const loaderEl = window.document.getElementById("preload");
  if (loaderEl && loaderEl.parentNode) {
    loaderEl.parentNode.removeChild(loaderEl);
  }
});
